export enum ASSESSMENT_TYPES {
  ACCREDITATION = "ACCREDITATION",
  APPLICATION = "APPLICATION",
}
